import React from 'react';
import { getLoanAmount } from '../modules/loan-size';

const CardLense = (key) => (Card, id, props, completed) => {
  const Wrapped = ({ model, onChange, ...wrappedProps }) => (
    <Card
      {...props}
      {...wrappedProps}
      scenario={model.getIn(['loan', 'scenario'])}
      questionnaireState={
        model.getIn(['loan', 'preapprovalState']) || model.getIn(['loan', 'loanState'])
      }
      loanAmount={getLoanAmount(model)}
      model={model.get(key)}
      onChange={onChange.bind(null, key)}
      complete={!!Wrapped.completed({ model, scenario: model.getIn(['loan', 'scenario']) })}
    />
  );

  Wrapped.completed = ({ model, scenario }) => {
    model = model.get(key);
    return completed ? completed({ model, scenario }) : Card.completed({ model, scenario });
  };

  Wrapped.id = id || Card.id;
  return Wrapped;
};

const LoanCard = CardLense('loan');
const BorrowerCard = CardLense('borrower');
const CoborrowerCard = CardLense('coborrower');

export { LoanCard, BorrowerCard, CoborrowerCard };



// WEBPACK FOOTER //
// ./src/cards/card-lenses.js